import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";

export default function OzMinerals(){

  return(

    <>
    <Helmet title="Oz Minerals - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="OZ MINERALS" link1={"Projetos/ "} link2={"OZ MINERALS"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                   FACILITIES - OZ MINERALS
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Prestação de serviços de limpeza e conservação de áreas verdes, gestão de armazém e de expedição de minério nos projetos: Antas Norte, Pedra Branca, Exploração, Santa Lúcia e Pantera.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
              <h2>Informações do Projeto</h2>
              <ul>
                <li><strong>Cliente: </strong> OZ MINERALS</li>
                <li><strong>Cidade: </strong> Curionópolis e Canaã dos Carajás - PA</li>
                <li><strong>Ano: </strong> 2023 </li>
                <li><strong>Segmento: </strong> Facilities </li>
              </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}